var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("CardInfoChip", {
                attrs: { message: _vm.reviewDate, gray: "" },
              }),
              _vm.buttonsShown
                ? _c(
                    "div",
                    { staticClass: "flex ml-auto" },
                    [
                      _c("DeleteReviewButton", {
                        staticClass: "ml-auto mr-4",
                        attrs: { ratingId: _vm.ratingId },
                        on: {
                          reviewDeleted: function ($event) {
                            return _vm.$emit("reviewDeleted")
                          },
                        },
                      }),
                      _c("UIButton", {
                        attrs: {
                          buttonText: "Edit",
                          variant: "linkButton",
                          size: "no",
                        },
                        on: { click: _vm.toggleReviewModal },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "mb-3" },
          [
            _vm.reviewedByMe
              ? _c("Badge", {
                  staticClass: "inline-flex",
                  attrs: {
                    value: "Your review",
                    styleClasses: "py-0.5 px-2",
                    color: _vm.badgeColor.INFO,
                  },
                })
              : _c("CardBodySingleChip", {
                  attrs: {
                    label: "Review by",
                    withAvatar: "",
                    chipDetails: {
                      id: _vm.contractorId,
                      name: _vm.reviewerName,
                      routeParams: _vm.reviewerRouteParams,
                    },
                  },
                }),
            _vm._t("default"),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "w-full" },
          [
            _c("RatingStars", {
              staticClass: "-ml-0.5 mb-1",
              attrs: { value: _vm.score, starSize: 20, readOnly: "" },
            }),
            _c("div", [_vm._v(" " + _vm._s(_vm.review) + " ")]),
          ],
          1
        ),
      ]),
      _vm.dialog
        ? _c("ReviewModal", {
            attrs: {
              review: _vm.review,
              score: _vm.score,
              ratingId: _vm.ratingId,
              contractorId: _vm.contractorId,
              currentUserId: _vm.currentUserId,
            },
            on: { close: _vm.toggleReviewModal, editted: _vm.handleEditted },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }